import React from "react";
import { Carousel, Card } from "./AppleCardsCarousel";

export const AppleCardsCarouselDemo: React.FC = () => {
  const cards = data.map((card, index) => (
    <Card key={card.src} card={card} index={index} />
  ));

  return (
    <div className="w-full h-full py-20">
      <h2 className="max-w-7xl pl-4 mx-auto text-xl md:text-5xl font-bold text-neutral-800 dark:text-neutral-200 font-sans">
        Professional invoicing made simple.
      </h2>
      <Carousel items={cards} />
    </div>
  );
};

const InstantCreationContent = () => (
  <div className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl">
    <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl font-sans max-w-3xl mx-auto">
      <span className="font-bold text-neutral-700 dark:text-neutral-200">
        No setup required. Start creating invoices immediately.
      </span>{" "}
      Open your browser, start typing, and your professional invoice is ready. 
      No accounts, no onboarding flows, no friction - just pure productivity.
    </p>
  </div>
);

const ProfessionalDesignContent = () => (
  <div className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl">
    <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl font-sans max-w-3xl mx-auto">
      <span className="font-bold text-neutral-700 dark:text-neutral-200">
        Beautiful designs that make an impression.
      </span>{" "}
      Your invoices represent your business. Our carefully crafted templates 
      ensure every invoice looks professional and trustworthy.
    </p>
  </div>
);

const CloudSyncContent = () => (
  <div className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl">
    <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl font-sans max-w-3xl mx-auto">
      <span className="font-bold text-neutral-700 dark:text-neutral-200">
        Your invoices, everywhere you need them.
      </span>{" "}
      Seamless cloud synchronization keeps your invoices accessible from any device. 
      Start on your laptop, finish on your phone, never lose your work.
    </p>
  </div>
);

const PaymentTrackingContent = () => (
  <div className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl">
    <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl font-sans max-w-3xl mx-auto">
      <span className="font-bold text-neutral-700 dark:text-neutral-200">
        Stay on top of your cash flow.
      </span>{" "}
      Track payment status, send automatic reminders, and never wonder about 
      outstanding invoices again. Complete visibility into your business finances.
    </p>
  </div>
);

const EmailIntegrationContent = () => (
  <div className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl">
    <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl font-sans max-w-3xl mx-auto">
      <span className="font-bold text-neutral-700 dark:text-neutral-200">
        Send invoices directly from the platform.
      </span>{" "}
      No need to download and attach files. Send professional invoices directly 
      via email with customizable templates and automatic follow-ups.
    </p>
  </div>
);

const data = [
  {
    category: "Instant Creation",
    title: "Start invoicing immediately.",
    src: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2226&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    content: <InstantCreationContent />,
  },
  {
    category: "Professional Design",
    title: "Beautiful invoices that impress.",
    src: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2426&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    content: <ProfessionalDesignContent />,
  },
  {
    category: "Cloud Sync",
    title: "Access your invoices anywhere.",
    src: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2344&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    content: <CloudSyncContent />,
  },
  {
    category: "Payment Tracking",
    title: "Never miss a payment again.",
    src: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    content: <PaymentTrackingContent />,
  },
  {
    category: "Email Integration",
    title: "Send invoices directly via email.",
    src: "https://images.unsplash.com/photo-1596526131083-e8c633c948d2?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    content: <EmailIntegrationContent />,
  },
]; 